'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getUnownedProps = getUnownedProps;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUnownedProps(props, propTypes) {
    var thisPotentialProps = _lodash2.default.map(propTypes, function (v, k) {
        return k;
    });
    var allProps = _lodash2.default.map(props, function (v, k) {
        return k;
    });

    return _lodash2.default.reduce(allProps, function (p, k) {
        if (!_lodash2.default.includes(thisPotentialProps, k)) {
            p[k] = props[k];
        }
        return p;
    }, {});
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/@wix/wixrest-utils/dist/ReactUtils.js
// module id = 1139
// module chunks = 0